import script from "./HeaderList.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderList.vue?vue&type=script&setup=true&lang=js"

import "./HeaderList.vue?vue&type=style&index=0&id=ac0b6c88&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac0b6c88"]])

export default __exports__